import { GtmState, initialState } from './gtm.state';
import { ACTION_TYPES } from './gtm.action';

// Reducer
export default (state: GtmState = initialState, action): GtmState => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_CONTAINER_ID: {
      return {
        ...state,
        containerId: action.payload,
      };
    }
    case ACTION_TYPES.INITIALIZE_GTM: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
};
